import React from 'react';
import { Link } from 'react-router-dom';
import { Home, Key, FileText, Building2, Briefcase, FileSignature, ArrowRight } from 'lucide-react';
const INTENTS = [{
  title: 'Buying property',
  description: 'Contract review, title and risk checks, negotiations and settlement.',
  icon: Home,
  cta: 'Help me buy',
  href: '/buying-property'
}, {
  title: 'Selling property',
  description: 'Contract of sale, Section 32 preparation, buyer enquiries and settlement.',
  icon: Key,
  cta: 'Help me sell',
  href: '/selling-property'
}, {
  title: 'Reviewing a contract',
  description: 'Understand special conditions, disclosures and key risks before you sign.',
  icon: FileText,
  cta: 'Review my contract',
  href: '/contract-review'
}, {
  title: 'SMSF or trust purchase',
  description: 'Property transactions involving SMSFs, family trusts and unit trusts.',
  icon: Building2,
  cta: 'Help with my structure',
  href: '/smsf-trust-property'
}, {
  title: 'Commercial property',
  description: 'Legal support for commercial purchases, sales and leasing matters.',
  icon: Briefcase,
  cta: 'Commercial help',
  href: '/commercial-property'
}, {
  title: 'Transfer, subdivision or certificate',
  description: 'Property transfers, subdivisions and solicitor certificates.',
  icon: FileSignature,
  cta: 'Other property matters',
  href: '/property-transfers'
}];
export function IntentSelector() {
  return <section className="py-20 md:py-28 px-5 md:px-6 bg-background" data-id="element-300">
      <div className="max-w-7xl mx-auto" data-id="element-301">
        <div className="max-w-2xl mb-12 md:mb-14" data-id="element-302">
          <p className="text-accent font-script text-2xl mb-1" data-id="element-303">
            where do we start?
          </p>
          <h2 className="text-3xl md:text-[2.6rem] leading-tight text-ink" data-id="element-304">
            What do you need help with?
          </h2>
          <p className="mt-4 text-muted-ink text-lg" data-id="element-305">
            Tell us the situation and we will point you to the right pathway, or
            just upload the contract and let the team take it from there.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-306">
          {INTENTS.map(intent => {
          const Icon = intent.icon;
          return <Link key={intent.title} to={intent.href} className="group relative flex flex-col rounded-3xl border border-border bg-surface p-7 transition-all duration-300 ease-soft hover:-translate-y-1 hover:shadow-warm hover:border-accent/30" data-id="element-307">
                <div className="mb-6 inline-flex w-14 h-14 items-center justify-center rounded-2xl bg-accent-soft text-accent transition-colors group-hover:bg-accent group-hover:text-white" data-id="element-308">
                  <Icon className="w-6 h-6" strokeWidth={2} data-id="element-309" />
                </div>
                <h3 className="font-serif text-2xl text-ink mb-2" data-id="element-310">
                  {intent.title}
                </h3>
                <p className="text-muted-ink leading-relaxed mb-7" data-id="element-311">
                  {intent.description}
                </p>
                <span className="mt-auto inline-flex items-center gap-2 text-sm font-semibold text-accent" data-id="element-312">
                  {intent.cta}
                  <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" data-id="element-313" />
                </span>
              </Link>;
        })}
        </div>
      </div>
    </section>;
}